module.exports = __webpack_public_path__ + "img/pic_no_data@3x.f4563875.png";